export default function Canvas_Intro() {
  return (
    <div>
      <h1>Canvas_Intro Component</h1>
    </div>
  );
}
